import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ServiceUsagesGroups_Reorder_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ServiceUsagesGroups_Reorder(
      $groups: [ResolvableServiceUsagesGroupReorganizeInput!]!
      $serviceUserId: Id!
      $versionData: VersionDataInput
    ) {
      reorganizeMissionServiceUsagesGroups(
        groups: $groups
        serviceUserId: $serviceUserId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useReorderMissionServiceUsagesGroupsMutation = () =>
  useGraphQLMutation(
    MissionServicesInfoForm_ServiceUsagesGroups_Reorder_Mutation,
  );
